import axios from 'axios'
import { RUTA_SERVER, RUTA_SERVIDOR } from './config.js';

/** Esta API recibe todas las peticiones 
 ** de las paginas del Cliente y se comunica
 ** con EL SERVIDOR del Backend, específicamente
 ** con el archivo de rutas.js
 **
***************************** Peticiones GET para consultas *******************************************/
/** Esta ruta sirve para Autenticarse **/



export const sql = async (url, metodo, cuerpo) =>{
  try {
      const reg = await fetch(RUTA_SERVIDOR + url, {
        method: metodo,     //GET, POST, PUT   
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cuerpo),
      });

    const lista = await reg.json();
    return lista;

  } catch (error) {
    return error.message;
    }
}

export const sqlAdjunto = async (url, cuerpo) =>{
  try {
    console.log("LLego a la API")
    const resp = await axios.post(RUTA_SERVIDOR+url, cuerpo)
    return resp

  } catch (error) {
    return error.message
  }
}


export const getAcceso = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getAcceso', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const getAportantes = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getAportantes', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const getAportes = async (idProyecto) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getAportes', {idProyecto: idProyecto})
    return resp

  } catch (error) {
    return error.message
  }
}

export const getAsesores= async (idProyecto) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getAsesores',
      { idProyecto: idProyecto}
    );
    return resp
       
  } catch (error) {
    return error.message
  }
}


export const getAsesoresCargo= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getAsesoresCargo', datos)
    return resp
       
  } catch (error) {
    return error.message
  }
}

export const getCaracterizacion= async (idProyecto) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getCaracterizacion',
    { idProyecto: idProyecto});
    return resp
         
  } catch (error) {
    return error.message
  }
}

export const getCombos= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getCombos', datos);
    return resp
         
  } catch (error) {
    return error.message
  }
}

export const getDocumento= async (noDocumento) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getDocumento',
    {noDocumento: noDocumento});
    return resp
         
  } catch (error) {
    return error.message
  }
}

export const getForos= async (idProyecto) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getForos',
    {idProyecto: idProyecto});
    return resp
         
  } catch (error) {
    return error.message
  }
}


export const getForoOpinion= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getForoOpinion', datos)
    return resp
         
  } catch (error) {
    return error.message
  }
}

export const getFichaCaracterizacion= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getFichaCaracterizacion', datos);
    return resp
         
  } catch (error) {
    return error.message
  }
}


export const getCantidad= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getCantidad', datos);
    return resp
         
  } catch (error) {
    return error.message
  }
}

  
export const getIndicadorObjetivo= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getIndicadorObjetivo', datos);
    return resp
         
  } catch (error) {
    return error.message
  }
}

  
export const getIndicadorResultado= async (idProyecto) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getIndicadorResultado', {idProyecto:idProyecto});
    return resp
         
  } catch (error) {
    return error.message
  }
}
 

export const getUsuarios= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getUsuarios', datos);
    return resp
         
  } catch (error) {
    return error.message
  }
}

export const getCboMunicipios = async () =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getCboMunicipios');
    return resp
        
  } catch (error) {
    return error.message
  }
}


export const getContarAnexados = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getContarAnexados', datos);
    return resp
        
  } catch (error) {
    return error.message
  }
}

export const getChat = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getChat', datos);
    return resp
        
  } catch (error) {
    return error.message
  }
}



export const getObjetivoEspecifico = async (idProyecto) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getObjetivoEspecifico',{idProyecto:idProyecto});
    return resp
        
  } catch (error) {
    return error.message
  }
}

/**Trae el listado de participantes de un proyecto según el tipo*/
export const getParticipantes= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getParticipantes', datos)
    return resp
    
  } catch (error) {
    return error.message
  }
}



export const getPersonas= async (tipoParticipante) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getPersonas', {tipoParticipante:tipoParticipante})
    return resp
    
  } catch (error) {
    return error.message
  }
}
/** Devuelve los periodos en los cuales se deben registrar los archivos que se anexen */
export const getPeriodosAnexos= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getPeriodosAnexos', datos)
    return resp
    
  } catch (error) {
    return error.message
  }
}


export const getPlantillaFicha= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getPlantillaFicha',{
      tabla:datos
    })
    return resp
  } catch (error) {
    return error.message
  }
}

export const getPlantillaSencilla = async (tabla) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getPlantillaSencilla', {tabla: tabla})
    return resp

  } catch (error) {
    return error.message
  }
}

export const getPresentacion = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getPresentacion', datos)
    return resp
  } catch (error) {
    return error.message
  }
}

export const getPoblacion = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getPoblacion', datos)
    return resp
  } catch (error) {
    return error.message
  }
}


export const getProyectos = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getProyectos',datos)
    return resp
  } catch (error) {
    return error.message
  }
}


export const getProyectoActividad = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getProyectoActividad', datos)
    return resp
    
  } catch (error) {
    return error.message
  }
}

export const getProyectoActividadAnexos = async (idProyectoActividad) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getProyectoActividadAnexos', 
    {idProyectoActividad: idProyectoActividad})
    return resp

  } catch (error) {
    return error.message
  }
}


export const getProyectoActividadDesarrolloAnexos = async (idProyectoActividadDesarrollo) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getProyectoActividadDesarrolloAnexos', 
      {idProyectoActividadDesarrollo : idProyectoActividadDesarrollo})
    return resp

  } catch (error) {
    return error.message
  }
}

export const getProyectoActividades = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getProyectoActividades', datos)
    return resp
  } catch (error) {
    return error.message
  }
}

export const getProyectoParticipante = async (idParticipante) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getProyectoParticipante', {idParticipante:idParticipante})
    return resp

  } catch (error) {
    return error.message
  }
}

export const getProyectoParticipanteInfo = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getProyectoParticipanteInfo', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const getReuniones = async (idProyecto) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getReuniones', {idProyecto:idProyecto})
    return resp

  } catch (error) {
    return error.message
  }
}

export const getTipoDatoTabla= async () =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getTipoDatoTabla');
    return resp
         
  } catch (error) {
    return error.message
  }
}
  

export const getUsuario = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getUsuario', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const getUsuariosChat = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getUsuariosChat', datos)
    return resp

  } catch (error) {
    return error.message
  }
}


/** Verifica si un usuario visualizó una actividad */
export const getVerAnexosSeguimiento = async (idProyectoActividadSeguimiento) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getVerAnexosSeguimiento', 
    {
      idProyectoActividadSeguimiento:idProyectoActividadSeguimiento
    })
    return resp

  } catch (error) {
    return error.message
  }
}


/** Verifica si un usuario visualizó una actividad */
export const getVisualizada = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getVisualizada', datos)
    return resp

  } catch (error) {
    return error.message
  }
}





/** VoBo para una actividad de un asesor*/
export const getVisualizadaAnexo = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/getVisualizadaAnexo', datos)
    return resp

  } catch (error) {
    return error.message
  }
}



/***************************** Peticiones SET para consultas *******************************************/
export const setAsesor = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setAsesor', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

/**Graba los datos y el logo de la entidad aportante */
export const setAportante = async (formdata) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setAportante', formdata);
    return resp.data.id

  } catch (error) {
    return error.message
  }
}

export const setDatosAportante = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setDatosAportante', datos)
    return resp.data.Id

  } catch (error) {
    return error.message
  }
}

export const setAporte = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setAporte', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const setCaracterizacion = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setCaracterizacion', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const setEstado = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setEstado', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const setFichaCampos = async (info) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setFichaCampos', info)
    return resp

  } catch (error) {
    return error.message
  }
}


export const setIndicadorObjetivo = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setIndicadorObjetivo', datos);
    return resp
  } catch (error) {
    return error.message
  }
}

export const setIndicadorResultado= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setIndicadorResultado', datos);
    return resp
  } catch (error) {
    return error.message
  }
}

export const setIndicadorPoblacion= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setIndicadorPoblacion', datos);
    return resp
  } catch (error) {
    return error.message
  }
}

export const setUsuario = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setUsuario', datos);
    return resp

  } catch (error) {
    return error.message
  }
}


/**Actualiza los LIKE del foro */
export const setForoMeGusta = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/setForoMeGusta', datos);
    return resp

  } catch (error) {
    return error.message
  }
}

/**Graba la opinión de un participante del foro */
export const setForoOpinion = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setForoOpinion', datos);
    return resp

  } catch (error) {
    return error.message
  }
}


/** Esta ruta sirve para grabar datos de la Plantilla Sencilla **/
export const setPlantillaSencilla = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setPlantillaSencilla', datos)
    return resp

  } catch (error) {
    return error.message
  }
}


export const setProyecto= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setProyecto', datos)
    return resp

  } catch (error) {
    return error.message
  }
}


export const setProyectoActividad = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setProyectoActividad', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const setReunion = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setReunion', datos);
    return resp

  } catch (error) {
    return error.message
  }
}


export const setSubirAnexoAsesores = async (formData) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setSubirAnexoAsesores', formData);
    return resp

  } catch (error) {
    return error.message
  }
}

export const setProyectoActividadDesarrollo = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setProyectoActividadDesarrollo', datos);
    return resp

  } catch (error) {
    return error.message
  }
}


export const setSubirAnexoProyecto = async (formdata) =>{
  try {
    
    const resp = await axios.post(RUTA_SERVER+'/setSubirAnexoProyecto', formdata)
    return resp

  } catch (error) {
    return error.message
  }
}

export const setVisualizar = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setVisualizar', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const setVisualizada = async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setVisualizada', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const setAuditar= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/setAuditar', datos)
    return resp

  } catch (error) {
    return error.message
  }
}



/***************************** Peticiones UPDATE para consultas *******************************************/

export const setVoBoActividad = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/setVoBoActividad', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const updateAportante= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateAportante', datos )
    return resp

  } catch (error) {
    return error.message
  }
}

export const updateAsesor= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateAsesor', datos )
    return resp

  } catch (error) {
    return error.message
  }
}

export const updateCaracterizacion= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateCaracterizacion', datos )
    return resp

  } catch (error) {
    return error.message
  }
}


export const updateIndicadorObjetivo= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateIndicadorObjetivo', datos)
    return resp

 } catch (error) {
    return error.message
 }
}

export const updateIndicadorResultado= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateIndicadorResultado', datos)
    return resp

 } catch (error) {
    return error.message
 }
}


export const updateUsuario= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateUsuario', datos)
    return resp

 } catch (error) {
    return error.message
 }
}

/** Modifica los la foto personal**/
export const actualizarImagen= async (datos) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/setImagen', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

/** Modifica la Observación de una actividad subida**/
export const updateCampo = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateCampo', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

/** Modifica los datos de la plantilla sencilla **/
export const updatePlantillaSencilla = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updatePlantillaSencilla', datos)
    return resp

  } catch (error) {
    return error.message
  }
}


export const updateProyectoActividad= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateProyectoActividad', datos)
    return resp
  } catch (error) {
    return error.message
  }
}

export const updateProyectoActividadResultado = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateProyectoActividadResultado', datos)
    return resp
  } catch (error) {
    return error.message
  }
}

export const updateProyectoAportantes = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateProyectoAportantes', {
      datos: datos
    })
    return resp
  } catch (error) {
    return error.message
  }
}

export const updateProyecto = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateProyecto', {
      datos: datos
    })
    return resp
  } catch (error) {
    return error.message
  }
}

/** Sube el archivo de video de presentación del proyecto **/
export const updatePresentacion= async (formdata) =>{
  try {
    const resp = await axios.post(RUTA_SERVER+'/updatePresentacion', formdata)
    return resp

  } catch (error) {
    return error.message
  }
}


export const updateReunion = async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateReunion', datos)
    return resp

  } catch (error) {
    return error.message
  }
}

export const updateVisualizar= async (datos) =>{
  try {
    const resp = await axios.put(RUTA_SERVER+'/updateVisualizar', {
      datos: datos
    })
    return resp
  } catch (error) {
    return error.message
  }
}
